import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, Toast } from '../../services/toast.service';

/**
 * Renders the active toast stack as a fixed, non-blocking overlay. Mounted once
 * at the app root (<app-toast> in App). Purely presentational — all state lives
 * in {@link ToastService}. Styling uses the --wg-* tokens so it tracks the
 * light/dark theme without any per-mode logic here.
 */
@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
  private readonly toastService = inject(ToastService);
  readonly toasts = this.toastService.toasts;

  defaultSummary(severity: Toast['severity']): string {
    switch (severity) {
      case 'error':
        return 'Something went wrong';
      case 'warning':
        return 'Heads up';
      case 'success':
        return 'Done';
      default:
        return 'Info';
    }
  }

  dismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}
